export * from './default'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/default/index.ts